import { put, call, throttle } from "redux-saga/effects";
import { tinyURLRequest, MetaResult } from "./tinyURLModels";
import {
  tinyURLActions,
  successgetActualURL,
  failgetActualURL,
} from "./tinyURLActions";
import { GET_TINYURL_REQUEST } from "./tinyURLConstants";
import { getActualURLAPI } from "./tinyURLAPI";

function* getActualURL(action: tinyURLActions):any {
  try {
    const response = yield call(
      getActualURLAPI,
      action.payload as tinyURLRequest
    );
    const decryptdata = response?.data;
    if (response.status === 200) {
      const result = decryptdata as MetaResult;
      if (result.metaDataInfo.responseCode == "SUCCESS")
        yield put(successgetActualURL(decryptdata as MetaResult));
      else yield put(failgetActualURL());
    } else {
      yield put(failgetActualURL());
    }
  } catch (err) {
    console.error(err);
    yield put(failgetActualURL());
  }
}
export default function* tinyURLSaga() {
  yield throttle(5000, GET_TINYURL_REQUEST, getActualURL);
}
